<template>
    <div class="detail-contain">
        <div class="title" v-if="scoreType === 0">表彰奖励或入选专家库、人才库</div>
        <div class="title" v-if="scoreType === 1">参加公益活动</div>
        <div class="title" v-if="scoreType === 2">行政处罚及其他违规行为</div>
        <div class="title" v-if="scoreType === 3">其他不规范执业行为</div>
        <div class="picker-contain" v-if="scoreType === 0">
            <div class="picker-box">
                <div class="picker-name">奖励级别<span style="color:red">*</span></div>
                <div class="picker-body" @click="showType0Picker1">
                    <div class="picker-value">{{type0text1}}</div>
                    <img class="right-icon" src="../../assets/guideSystem/right_arrow.png" />
                </div>
            </div>
            <div class="picker-box">
                <div class="picker-name">奖励类型<span style="color:red">*</span></div>
                <div class="picker-body" @click="showType0Picker2">
                    <div class="picker-value">{{type0text2}}</div>
                    <img class="right-icon" src="../../assets/guideSystem/right_arrow.png" />
                </div>
            </div>
            <div class="picker-box">
                <div class="picker-name">奖励/证书发放日期<span style="color:red">*</span></div>
                <div class="picker-body" @click="showType0Picker3">
                    <div class="picker-value">{{type0text3}}</div>
                    <img class="right-icon" src="../../assets/guideSystem/right_arrow.png" />
                </div>
            </div>
        </div>
        <div class="picker-contain" v-if="scoreType === 1">
            <div class="picker-box">
                <div class="picker-name">公益活动名称<span style="color:red">*</span></div>
                <div>
                    <input v-model="type1name" class="picker-input" placeholder="请输入公益活动名称" placeholder-class="picker-place" />
                </div>
            </div>
            <div class="picker-box">
                <div class="picker-name">举办方<span style="color:red">*</span></div>
                <div class="content">云南志愿者协会</div>
            </div>
            <div class="picker-box">
                <div class="picker-name">参加活动日期<span style="color:red">*</span></div>
                <div class="picker-body" @click="showType1Picker1">
                    <div class="picker-value">{{type1text1}}</div>
                    <img class="right-icon" src="../../assets/guideSystem/right_arrow.png" />
                </div>
            </div>
        </div>
        <div class="picker-contain" v-if="scoreType === 2">
            <div class="picker-box">
                <div class="picker-name">类型<span style="color:red">*</span></div>
                <div class="picker-body" @click="showType2Picker1">
                    <div class="picker-value">{{type2text1}}</div>
                    <img class="right-icon" src="../../assets/guideSystem/right_arrow.png" />
                </div>
            </div>
            <div class="picker-box" v-if="showPicker2">
                <div class="picker-name">详细类型<span style="color:red">*</span></div>
                <div class="picker-body" @click="showType2Picker2">
                    <div class="picker-value">{{type2text2}}</div>
                    <img class="right-icon" src="../../assets/guideSystem/right_arrow.png" />
                </div>
            </div>
            <div class="picker-box">
                <div class="picker-name">处罚日期<span style="color:red">*</span></div>
                <div class="picker-body" @click="showType2Picker3">
                    <div class="picker-value">{{type2text3}}</div>
                    <img class="right-icon" src="../../assets/guideSystem/right_arrow.png" />
                </div>
            </div>
        </div>
        <div class="picker-contain" v-if="scoreType === 3">
            <div class="picker-box">
                <div class="picker-name">类型<span style="color:red">*</span></div>
                <div class="picker-body" @click="showType3Picker1">
                    <div class="picker-value">{{type3text1}}</div>
                    <img class="right-icon" src="../../assets/guideSystem/right_arrow.png" />
                </div>
            </div>
            <div class="picker-box">
                <div class="picker-name">处罚日期<span style="color:red">*</span></div>
                <div class="picker-body" @click="showType3Picker2">
                    <div class="picker-value">{{type3text2}}</div>
                    <img class="right-icon" src="../../assets/guideSystem/right_arrow.png" />
                </div>
            </div>
        </div>
        <div class="content-contain">
            <div class="content-title">{{descTitle}}</div>
                <van-field
                    v-model="message"
                    type="textarea"
                    placeholder="请输入情况描述…"
                    input-class="textarea"
                    :autosize="autoSize"
                />
        </div>
        <div class="file-contain">
            <div class="file-title">附件</div>
            <div class="img-contain">
                <div class="posting-uploader-item" v-for="(item,nn) in postData" :key="nn">
                    <img :src="item.content" alt="图片" class="imgPreview">
                    <img src="../../assets/guideSystem/delete.png" class="delte" @click="delImg(nn)">
                    <!-- <van-icon name="close" @click="delImg(nn)" class="delte"/> -->
                </div>
                <van-uploader :after-read="onRead" multiple="true" :accept="'image/*'">
                    <!-- <img src="../../assets/guideSystem/ic_upload.png" alt="等待传图" class="imgPreview"> -->
                </van-uploader>
            </div>
        </div>
        <common-picker ref="type0Picker1" :typeList="type0Picker1Column" :cols="cols1" @getTypeValue="getType0Picker1Value"></common-picker>
        <common-picker ref="type0Picker2" :typeList="type0Picker2Column" :cols="cols1" @getTypeValue="getType0Picker2Value"></common-picker>
        <time-picker ref="type0Picker3" @getTimeValue="getType0Picker3Value"></time-picker>
        <time-picker ref="type1Picker1" @getTimeValue="getType1Picker1Value"></time-picker>
        <common-picker ref="type2Picker1" :typeList="type2Picker1Column" :cols="cols1" @getTypeValue="getType2Picker1Value"></common-picker>
        <common-picker ref="type2Picker2" :typeList="type2Picker2Column" :cols="cols1" @getTypeValue="getType2Picker2Value"></common-picker>
        <time-picker ref="type2Picker3" @getTimeValue="getType2Picker3Value"></time-picker>
        <common-picker ref="type3Picker1" :typeList="type3Picker1Column" :cols="cols1" @getTypeValue="getType3Picker1Value"></common-picker>
        <time-picker ref="type3Picker2" @getTimeValue="getType3Picker2Value"></time-picker>
        <div class="btn-box">
            <button class="cancel" @click="back">取消</button>
            <button class="submit" v-if="scoreType === 0" :disabled="(type0value1 !== '' && type0value2 !== '' && type0value3 !== '' && message !== '' && uploadTemp.length > 0) ? false:true" @click="uploadApi">上传</button>
            <button class="submit" v-if="scoreType === 1" :disabled="(type1name !== '' && type1value1 !== '' && message !== '' && uploadTemp.length > 0) ? false:true" @click="uploadApi">上传</button>
            <button class="submit" v-if="scoreType === 2" :disabled="(type2value1 !== '' && type2value3 !== '' && message !== '' && uploadTemp.length > 0) ? false:true" @click="uploadApi">上传</button>
            <button class="submit" v-if="scoreType === 3" :disabled="(type3value1 !== '' && type3value2 !== '' && message !== '' && uploadTemp.length > 0) ? false:true" @click="uploadApi">上传</button>
        </div>
    </div>
</template>
<script>
    import api from '../../service/modules/guide'
    import commonPicker from '../../components/base/commonPicker'
    import timePicker from '../../components/base/timePick'
    const HTTPS = 'https://'
    export default {
        components: {
            commonPicker,
            timePicker
        },

        data () {
            return {
                cutPointList: [
                    { 'title': '受到治安处罚警告', 'time': '2019-11-13  20:41', 'point': '5.0' },
                    { 'title': '受到治安处罚警告', 'time': '2019-11-13  20:41', 'point': '5.0' },
                    { 'title': '受到治安处罚警告', 'time': '2019-11-13  20:41', 'point': '5.0' }
                ],
                guideId: '',
                scoreType: 0, // 上传评分材料类型  0 1 2 3
                postData: [], // 图片显示临时存储
                tempFile: [],
                uploadTemp: [],
                autoSize: { 'maxHeight': 120, 'minHeight': 120 },
                message: '',
                cols1: 1,
                type0value1: '',
                type0value2: '',
                type0value3: '',
                type1name: '',
                type1value1: '',
                type2value1: '',
                type2value2: '',
                type2value3: '',
                type3value1: '',
                type3value2: '',
                type0text1: '',
                type0text2: '',
                type0text3: '',
                type1text1: '',
                type2text1: '',
                type2text2: '',
                type2text3: '',
                type3text1: '',
                type3text2: '',
                type0Picker1Column: [[
                    {
                        text: '国家级', value: 'national', major: [{ text: '表彰奖励', value: 'award' }, { text: '入选人才库/专家库', value: 'expert' }]
                    },
                    {
                        text: '省部级', value: 'province', major: [{ text: '表彰奖励', value: 'award' }, { text: '入选人才库/专家库', value: 'expert' }]
                    },
                    {
                        text: '厅局级', value: 'bureau', major: [{ text: '表彰奖励', value: 'award' }]
                    },
                    {
                        text: '行业协会', value: 'association', major: [{ text: '表彰奖励', value: 'award' }]
                    }]],
                type0Picker2Column: [],
                type2Picker1Column: [[
                    {
                        text: '罚款处罚', value: 'fine', major: [{ text: '被处20000元以上', value: '20000' }, { text: '被处10000元以上20000元以下', value: '10000' }, { text: '被处3000元以上10000元以下', value: '3000' }, { text: '被处1000元以上3000元以下', value: '1000' }, { text: '被处1000元以下', value: '0' }]
                    },
                    {
                        text: '暂扣导游证', value: 'withholdCertificate', major: []
                    },
                    {
                        text: '治安处罚', value: 'securityPenalties', major: [{ text: '被处治安拘留', value: 'custody' }, { text: '被处罚款', value: 'fine' }, { text: '被处警告', value: 'warning' }]
                    },
                    {
                        text: '负面舆情', value: 'negativeSentiment', major: [{ text: '一级负面舆情', value: 'level1' }, { text: '二级负面舆情', value: 'level2' }, { text: '三级负面舆情', value: 'level3' }]
                    }]],
                type2Picker2Column: [],
                showPicker2: true,
                type3Picker1Column: [[
                    {
                        text: '未履行安全提示职责或事故报告职责', value: 'noSafetyNotice'
                    },
                    {
                        text: '未履行文明旅游提醒职责', value: 'noCivilizationNotice'
                    },
                    {
                        text: '不按规定着装或仪容仪表不得体', value: 'disorderClothing'
                    }]],
                descTitle: ''
            };
        },

        computed: {},

        watch: {},

        methods: {
            onRead (file) { // 上传图片到图片服务器
                this.tempFile = []
                if (Array.isArray(file)) {
                    // 多图
                    for (let index = 0; index < file.length; index++) {
                        this.postData.push(file[index])
                        this.tempFile.push(file[index])
                    }
                } else {
                    // 单图
                    this.postData.push(file)
                    this.tempFile.push(file)
                }
                this.uploadFile()
            },
            getSession () {
                api.getCosSession().then(res => {
                    if (res.ret === 0) {
                        this.cosArg = res.data
                        this.cos = new COS({
                            getAuthorization: function (options, callback) {
                                callback({
                                    TmpSecretId: res.data.credentials && res.data.credentials.tmpSecretId,
                                    TmpSecretKey: res.data.credentials && res.data.credentials.tmpSecretKey,
                                    XCosSecurityToken: res.data.credentials && res.data.credentials.sessionToken,
                                    ExpiredTime: res.data.expiredTime
                                });
                            }
                        })
                    }
                });
            },
            uploadFile () {
                let cosKey = ''
                console.log('this.tempFile:', this.tempFile)
                for (let i = 0; i < this.tempFile.length; i++) {
                    cosKey = `${this.cosArg.keyPrefix}/${new Date().getTime()}/${this.tempFile[i].file.name}`
                    this.cos.putObject({
                        Bucket: this.cosArg.bucket,
                        Region: this.cosArg.region,
                        Key: cosKey,
                        Body: this.tempFile[i].file,
                        onHashProgress: function (progressData) {
                            console.log('校验中', JSON.stringify(progressData));
                        },
                        onProgress: function (progressData) {
                            console.log('上传中', JSON.stringify(progressData));
                        }
                    }, (err, res) => {
                        console.log(err, res);
                        if (!err) {
                            this.uploadTemp.push(HTTPS + res.Location)
                            console.log('this.uploadTemp:', this.uploadTemp)
                        }
                    })
                }
            },
            delImg (index) {
                // 删除指定下标的图片对象
                if (isNaN(index) || index >= this.postData.length) {
                    return false
                }
                let tmp = []
                let upTmp = []
                for (let i = 0, len = this.postData.length; i < len; i++) {
                    if (this.postData[i] !== this.postData[index]) {
                        tmp.push(this.postData[i])
                        upTmp.push(this.uploadTemp[i])
                    }
                }
                this.postData = tmp
                this.uploadTemp = upTmp
                console.log('this.uploadTemp:', this.uploadTemp)
            },
            // type0 picker
            showType0Picker1 () {
                this.$refs.type0Picker1.showPicker();
            },
            showType0Picker2 () {
                this.$refs.type0Picker2.showPicker();
            },
            showType0Picker3 () {
                this.$refs.type0Picker3.showPicker();
            },
            getType0Picker1Value (res) {
                this.type0value1 = res[0].value
                this.type0text1 = res[0].text
                for (let index = 0; index < this.type0Picker1Column[0].length; index++) {
                    if (this.type0Picker1Column[0][index].text === res[0].text) {
                        this.type0Picker2Column = []
                        this.type0Picker2Column.push(this.type0Picker1Column[0][index].major)
                        this.type0value2 = this.type0Picker1Column[0][index].major[0].value
                        this.type0text2 = this.type0Picker1Column[0][index].major[0].text
                        this.$refs.type0Picker2._initFresh();
                    }
                }
            },
            getType0Picker2Value (res) {
                this.type0value2 = res[0].value
                this.type0text2 = res[0].text
            },
            getType0Picker3Value (res) {
                this.type0value3 = new Date(res).getTime()
                this.type0text3 = res
            },
            // type1 picker
            showType1Picker1 () {
                this.$refs.type1Picker1.showPicker();
            },
            getType1Picker1Value (res) {
                this.type1value1 = new Date(res).getTime()
                this.type1text1 = res
            },
            // type2 picker
            showType2Picker1 () {
                this.$refs.type2Picker1.showPicker();
            },
            showType2Picker2 () {
                this.$refs.type2Picker2.showPicker();
            },
            showType2Picker3 () {
                this.$refs.type2Picker3.showPicker();
            },
            getType2Picker1Value (res) {
                this.type2value1 = res[0].value
                this.type2text1 = res[0].text
                for (let index = 0; index < this.type2Picker1Column[0].length; index++) {
                    if (this.type2Picker1Column[0][index].text === res[0].text) {
                        this.type2Picker2Column = []
                        if (this.type2Picker1Column[0][index].major.length > 0) {
                            this.showPicker2 = true
                            this.type2Picker2Column.push(this.type2Picker1Column[0][index].major)
                            this.type2value2 = this.type2Picker1Column[0][index].major[0].value
                            this.type2text2 = this.type2Picker1Column[0][index].major[0].text
                            this.$refs.type2Picker2._initFresh();
                        } else {
                            this.showPicker2 = false
                            this.type2value2 = ''
                        }
                    }
                }
            },
            getType2Picker2Value (res) {
                this.type2value2 = res[0].value
                this.type2text2 = res[0].text
            },
            getType2Picker3Value (res) {
                this.type2value3 = new Date(res).getTime()
                this.type2text3 = res
            },
            // type3 picker
            showType3Picker1 () {
                this.$refs.type3Picker1.showPicker();
            },
            showType3Picker2 () {
                this.$refs.type3Picker2.showPicker();
            },
            getType3Picker1Value (res) {
                this.type3value1 = res[0].value
                this.type3text1 = res[0].text
            },
            getType3Picker2Value (res) {
                this.type3value2 = new Date(res).getTime()
                this.type3text2 = res
            },
            // 日期补0
            addZero () {
                var now = new Date()
                var year = now.getFullYear()
                var month = now.getMonth() + 1
                var day = now.getDate()
                var clock = year + '-'
                if (month < 10) {
                    clock += '0'
                }
                clock += month + '-'
                if (day < 10) {
                    clock += '0'
                }
                clock += day
                return clock
            },
            // 上传接口
            uploadApi () {
                let updata = {}
                if (this.scoreType === 0) {
                    updata = {
                        awardLevel: this.type0value1,
                        awardType: this.type0value2,
                        awardTime: this.type0value3,
                        awardDesc: this.message,
                        attach: JSON.stringify(this.uploadTemp),
                        guideId: this.guideId
                    }
                    console.log('updata:', updata)
                    api.addAward(updata).then(res => {
                        if (res.ret === 0) {
                            this.$Toast.success('上传成功');
                            this.back()
                        }
                    })
                } else if (this.scoreType === 1) {
                    updata = {
                        eventName: this.type1name,
                        eventSponsor: '云南志愿者协会',
                        eventTime: this.type1value1,
                        eventDesc: this.message,
                        attach: JSON.stringify(this.uploadTemp),
                        guideId: this.guideId
                    }
                    console.log('updata:', updata)
                    api.addPublicWelfare(updata).then(res => {
                        if (res.ret === 0) {
                            this.$Toast.success('上传成功');
                            this.back()
                        }
                    })
                } else if (this.scoreType === 2) {
                    updata = {
                        punishType: this.type2value1,
                        punishDetailType: this.type2value2,
                        punishTime: this.type2value3,
                        punishDesc: this.message,
                        attach: JSON.stringify(this.uploadTemp),
                        guideId: this.guideId
                    }
                    console.log('updata:', updata)
                    api.addPunish(updata).then(res => {
                        if (res.ret === 0) {
                            this.$Toast.success('上传成功');
                            this.back()
                        }
                    })
                } else if (this.scoreType === 3) {
                    updata = {
                        disorderType: this.type3value1,
                        disorderTime: this.type3value2,
                        disorderDesc: this.message,
                        attach: JSON.stringify(this.uploadTemp),
                        guideId: this.guideId
                    }
                    console.log('updata:', updata)
                    api.addDisorder(updata).then(res => {
                        if (res.ret === 0) {
                            this.$Toast.success('上传成功');
                            this.back()
                        }
                    })
                }
            },
            beforeunloadFn (e) {
                console.log('刷新或关闭')
                this.message = ''
                this.uploadTemp = ''
            },
            back () {
                this.$router.go(-1);// 返回上一层
            }
        },

        mounted () {
            this.getSession()
            this.guideId = this.$route.query.guideId
            this.scoreType = parseInt(this.$route.query.type || '0', 10)
            // type0
            if (this.scoreType === 0) {
                this.descTitle = '奖励入选情况'
                this.type0value1 = this.type0Picker1Column[0][0].value
                this.type0text1 = this.type0Picker1Column[0][0].text
                this.type0value2 = this.type0Picker1Column[0][0].major[0].value
                this.type0text2 = this.type0Picker1Column[0][0].major[0].text
                this.type0value3 = new Date(this.addZero()).getTime()
                this.type0text3 = this.addZero()
                this.type0Picker2Column.push(this.type0Picker1Column[0][0].major)
            } else if (this.scoreType === 1) {
                this.descTitle = '公益活动情况'
                this.type1value1 = new Date(this.addZero()).getTime()
                this.type1text1 = this.addZero()
            } else if (this.scoreType === 2) {
                this.descTitle = '行政处罚/违规行为详情'
                this.type2value1 = this.type2Picker1Column[0][0].value
                this.type2text1 = this.type2Picker1Column[0][0].text
                this.type2value2 = this.type2Picker1Column[0][0].major[0].value
                this.type2text2 = this.type2Picker1Column[0][0].major[0].text
                this.type2value3 = new Date(this.addZero()).getTime()
                this.type2text3 = this.addZero()
                this.type2Picker2Column.push(this.type2Picker1Column[0][0].major)
            } else if (this.scoreType === 3) {
                this.descTitle = '不规范执业行为情况'
                this.type3value1 = this.type3Picker1Column[0][0].value
                this.type3text1 = this.type3Picker1Column[0][0].text
                this.type3value2 = new Date(this.addZero()).getTime()
                this.type3text2 = this.addZero()
            }
        },
        created () {
            window.addEventListener('beforeunload', e => this.beforeunloadFn(e))
        },
        destroyed () {
            window.removeEventListener('beforeunload', e => this.beforeunloadFn(e))
        }
    }
</script>
<style scoped lang="less">
.detail-contain{
    display: flex;
    flex-direction: column;
    background:rgba(251,251,251,1);
    .title{
        margin-top: 24px;
        margin-left: 12px;
        font-size:16px;

            font-family: PingFang SC, Arial, sans-serif;
            -webkit-font-smoothing: antialiased;
        font-weight:500;
        color:rgba(51,51,51,1);
        line-height:16px;
    }
    .picker-contain{
        margin: 12px 12px 0;
        background:rgba(255,255,255,1);
        box-shadow:0px 0px 10px 0px rgba(0,0,0,0.04);
        border-radius:3px;
        .picker-box{
            padding: 16px 13px 16px 16px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            border-bottom: 1px solid #eeeeee;
            .picker-name{
                font-size:14px;
                font-family:PingFangSC-Regular,PingFang SC;
                font-weight:400;
                color:rgba(153,153,153,1);
                line-height:14px;
            }
            .picker-input{
                font-size:14px;
                font-family:PingFangSC-Regular,PingFang SC;
                font-weight:400;
                color:rgba(51,51,51,1);
                line-height:14px;
                text-align: right;
            }
            .picker-body{
                display: flex;
                align-items: center;
                .picker-value{
                    font-size:14px;
                    font-family:PingFangSC-Regular,PingFang SC;
                    font-weight:400;
                    color:rgba(51,51,51,1);
                    line-height:14px;
                    margin-right: 4px;
                }
                .right-icon{
                    width: 12px;
                    height: 12px;
                }
            }
        }
        .picker-box:last-child{
            border-bottom: 0!important;
        }
    }
    .file-contain{
        display: flex;
        flex-direction: column;
        margin-left: 12px;
        margin-bottom: 60px;
        .file-title{
            font-size:14px;
            font-family:PingFangSC-Regular,PingFang SC;
            font-weight:400;
            color:rgba(51,51,51,1);
            line-height:14px;
        }
        .img-contain{
            display: flex;
            flex-wrap: wrap;
            margin-top: 13px;
            .posting-uploader-item{
                width: 77px;
                height: 77px;
                position: relative;
                margin-right: 13px;
                margin-bottom: 13px;
                .imgPreview{
                    width: 100%;
                    height: 100%;
                }
                .delte{
                    width: 14px;
                    height: 14px;
                    position: absolute;
                    top: -7px;
                    right: -7px;
                    z-index: 10;
                }
            }
            .van-uploader{
                position: relative;
                top: 0!important;
            }
            .imgPreview{
                width: 77px;
                height: 77px;
            }
        }
    }
    .content-contain{
        margin-top: 16px;
        display: flex;
        flex-direction: column;
        padding: 0 12px;
        margin-bottom: 16px;
        .content-title{
            font-size:14px;
            font-family:PingFangSC-Regular,PingFang SC;
            font-weight:400;
            color:rgba(51,51,51,1);
            line-height:14px;
        }
        .van-cell{
            background:rgba(245,245,245,1);
            border-radius:3px;
            padding: 16px;
            margin-top: 12px;
        }
        .textarea{
            min-height: 400px!important;
        }
        .input-box{
            margin-top: 12px;
        }
    }
    .btn-box{
        position: fixed;
        bottom: 0;
        width: 100%;
        height: 60px;
        background:rgba(255,255,255,1);
        box-shadow:0px -2px 8px 0px rgba(0,0,0,0.03);
        display: flex;
        padding: 0 15px;
        justify-content: space-between;
        align-items: center;
        .cancel{
            width:165px;
            height:40px;
            background: #ffffff;;
            color: rgba(54,179,116,1);
            border-radius:3px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size:17px;
            font-family:PingFangSC-Regular,PingFang SC;
            font-weight:400;
            line-height:16px;
            border: 1px solid rgba(54,179,116,1);
        }
        .submit{
            width:165px;
            height:40px;
            background:rgba(54,179,116,1);
            color: #ffffff;
            border-radius:3px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size:17px;
            font-family:PingFangSC-Regular,PingFang SC;
            font-weight:400;
            color:rgba(255,255,255,1);
            line-height:16px;
            border: 0;
        }
    }
}
</style>
